import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import styles from './AutoReplyWarningMessage.module.css';
import * as utils from '../../../../../helpers/utils';
import warningImage from '../../../../../assets/images/warning.svg';
import { useRootStore } from '../../../../../mobx/bridge';
import PopperWrapper from '../../PopperWrapper/PopperWrapper';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const AutoReplyWarningMessage = observer(function AutoReplyWarningMessage(props) {
  const { commonStore } = useRootStore();
  const { selectedAutoReplyType, onClose } = props; // data,
  const { t } = useTranslation();

  const isAutoReplyWarningOpen = Boolean(commonStore.selectedAutoReplySwitch);

  const titles = commonStore.conflicts?.scheduleConflicts;
  let warningText;

  if (selectedAutoReplyType === utils.AutoReplyTypeEnum.CustomAwayMessage.TypeId) {
    warningText = (
      <>
        {t('AutoReplyWarningMessage.ErrorMessage')} <b>{titles}</b>{' '}
        {t('AutoReplyWarningMessage.IsCurrentlyActive')}
      </>
    );
  } else if (selectedAutoReplyType === utils.AutoReplyTypeEnum.ScheduledAutoReply.TypeId) {
    warningText = (
      <>
        {t('AutoReplyWarningMessage.ScheduledAutoReplyConflict1')} <b>{titles}</b>.{' '}
        {t('AutoReplyWarningMessage.ScheduledAutoReplyConflict2')}
      </>
    );
  }

  return (
    <PopperWrapper
      isOpen={isAutoReplyWarningOpen}
      anchorEl={commonStore.selectedAutoReplySwitch}
      arrow
      arrowDirection="right"
      onClose={onClose}
      containerClass={styles.positionFix}
    >
      <Grid
        component="div"
        container
        justify="center"
        alignItems="center"
        className={styles.container}
      >
        <Grid component="div" container item xs={12} justify="center" alignItems="center">
          <img src={warningImage} alt={t('Common.Warning')} className={styles.warningImage} />
        </Grid>
        <Grid component="div" container item xs={12} justify="center" alignItems="center">
          <span className={styles.warningLabel}>{t('Common.Warning')}</span>
        </Grid>
        <Grid component="div" container item xs={12} justify="center" alignItems="center">
          <span className={styles.warningText}>{warningText}</span>
        </Grid>
        <Grid
          component="div"
          container
          item
          xs={12}
          justify="center"
          alignItems="center"
          className={styles.buttonContainer}
        >
          <button
            type="button"
            className={[styles.btn, styles.cancelBtn].join(' ')}
            onClick={onClose}
          >
            {t('Common.Cancel')}
          </button>
        </Grid>
      </Grid>
    </PopperWrapper>
  );
});
AutoReplyWarningMessage.whyDidYouRender = true;
AutoReplyWarningMessage.displayName = 'AutoReplyWarningMessage';

export default AutoReplyWarningMessage;
